import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import IconButton from './buttons/IconButton';
import SidePanel from './SidePanel';
import { THICKNESS_TOOLBAR, THICKNESS_ICONS } from '../constants/thicknesses';

const ThicknessWrapDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;

  //hide IconButton label
  :hover a:after {
    display: none !important;
  }
`;

const SidePanelThickness = ({
  currentThicknessKey,
  onSelectThicknessOption,
  onClose,
}) => (
  <SidePanel title="Thickness" showCloseButton onClose={onClose}>
    <ThicknessWrapDiv>
      {THICKNESS_TOOLBAR.map((option) => {
        const isSelected = option.key === currentThicknessKey;
        return (
          <IconButton
            key={option.key}
            icon={THICKNESS_ICONS[option.key]}
            selected={isSelected}
            onClick={() => {
              onSelectThicknessOption(option);
              onClose();
            }}
          />
        );
      })}
    </ThicknessWrapDiv>
  </SidePanel>
);

SidePanelThickness.propTypes = {
  currentThicknessKey: PropTypes.string.isRequired,
  onSelectThicknessOption: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SidePanelThickness;
